import React, { useState } from 'react';

import { CardBankPayout, FieldBold, Tooltip } from '../../../../components';
import helpers from '../../../../services/helpers';
import utils from '../../../../services/utils';
import ResumeInvoiceCard from '../ResumeInvoiceCard/ResumeInvoiceCard';
import { ReactComponent as CircleExclamation } from '../../../../assets/icons/CircleExclamation.svg';

import classes from './ResumePay.module.scss';

const ResumePay = ({
  suppliersGrouping,
  totalValueToPay,
  setSuppliersGrouping,
  costTransaction,
  invoiceAndSupplier,
  isMobil = false,
  invoicesSelected,
  methodForPay,
  showFee = false
}) => {
  const [showState] = useState(suppliersGrouping.reduce((prev, { info }) => ({ ...prev, [info.supplierId]: true }), {}));

  return (
    <div className={`${classes['card-suppliers']} ${!isMobil ? classes.desktop : classes.mobil}`}>
      <div className={classes['resume-pay']}>
        <span className={`${classes.mobile} bold-20`}>Resumen del pago</span>

        <span className={`${classes.text} ${classes.mobile} medium-14`}>{invoiceAndSupplier}</span>
        {showFee && (
          <div className={classes.totals}>
            <div className={classes.tooltip}>
              <span className='medium-14'>Costo transacción</span>
              <Tooltip
                classNameChildren={classes.tooltip}
                position='bottom-left'
                content={`Una transacción es un movimiento que se realiza a una cuenta bancaria. Si haces pagos múltiples, estas son varias transacciones con un costo de ${utils.moneyFormat(
                  costTransaction
                )} cada una.`}>
                <CircleExclamation />
              </Tooltip>
            </div>
            <span className='medium-14'>
              <span style={{ textDecoration: 'line-through', opacity: 0.7 }}>
                {utils.moneyFormat(costTransaction * suppliersGrouping.length)}
              </span>
            </span>
          </div>
        )}
        <div className={`${classes['button-more']} ${classes.mobile}`}>
          <div className={classes['total-main']}>
            <span className='semibold-20'>TOTAL</span>
            <span className='semibold-20'>{utils.moneyFormat(totalValueToPay)}</span>
          </div>
          {showFee && (
            <span className={`${classes['total-explanation']} medium-12`}>
              *Fees de transacción: <span style={{ textDecoration: 'line-through', opacity: 0.7 }}>{utils.moneyFormat(costTransaction * suppliersGrouping.length)}</span> (Descuento especial)
            </span>
          )}
        </div>
        <div className={classes.details}>
          {/* <span>Detalle A - 20.000</span>
          <span>Detalle B - 30.000</span>
          <span>Detalle C - 50.000</span> */}
        </div>
      </div>
      {suppliersGrouping.map(({ info, invoices }, supplierIdx) => {
        const infoBank = info.options.find(option => option.druoAccountId === info.druoAccountId);
        return (
          <div key={supplierIdx} className={classes['info-supplier']}>
            <FieldBold title='PROVEEDOR' value={info.businessName} />
            <FieldBold
              className={classes.total}
              title='TOTAL A PAGAR'
              value={utils.moneyFormat(helpers.getInvoicesTotalValueToPay(invoices))}
            />
            <span className={`${classes.color} ${classes['text-destiny']} medium-12`}>CUENTA DESTINO</span>

            <CardBankPayout
              className={classes.destiny}
              isButton={false}
              bankId={infoBank?.bankId}
              subtypeLabel={infoBank?.subtypeLabel}
              bankLast4Digits={infoBank?.bankLast4Digits}
            />
            <div className={`${classes['button-more']} ${classes['invoices-more']}`}>
              <FieldBold title='CANTIDAD DE CUENTAS DE COBRO' value={`${invoices.length} cuenta${invoices.length === 1 ? "" : "s"} de cobro`} />
              {/* <ShowArrowButton onClick={() => setShowHandler(info.supplierId)} showState={showState[info.supplierId]} /> */}
            </div>
            {showState[info.supplierId] &&
              invoices.map((invoice, invoiceIdx) => (
                <ResumeInvoiceCard
                  key={`${supplierIdx}-${invoiceIdx}`}
                  invoiceIdx={invoiceIdx}
                  supplierIdx={supplierIdx}
                  invoicesSelected={invoicesSelected}
                  invoice={invoice}
                  setSuppliersGrouping={setSuppliersGrouping}
                  costTransaction={showFee ? costTransaction : 0}
                  methodForPay={methodForPay}
                />
              ))}
          </div>
        );
      })}
    </div>
  );
};

export default ResumePay;
